export default function cycleDown(index, count) {
    var result = index - 1;

    return result < 0 ? count - 1 : result;
}
